import { DATA_SEARCH } from '../types'

export const searchAction = (search_action) => ({
    type: DATA_SEARCH,
    payload: search_action
})